// i18n ignore
import { memoize, omit } from 'lodash';
import { globalConstantService } from '@/workbench/modules/services/global-constant';
import { getDataSchemaType } from '@utils/data-schema-helper';
import { getGlobalConstantSchema } from '@/utils/global/api-schema';
import { getGogoBackendEnabled } from '@/modules/ai-page/useGogo';
/**
 * 获取全局常量类型定义
 */
const getGlobalConstantDts = memoize(async (projectId) => {
    if (window.w?.mode !== 'editor' || !projectId)
        return { typeDts: '', allTypeDts: '' };
    const constList = await globalConstantService.list(projectId);
    const frontConstantList = constList.filter(item => !item.onlyBackend);
    const opt = { dept: 1, forceFieldsRequired: true };
    const dts = getDataSchemaType(omit(getGlobalConstantSchema(frontConstantList), 'id'), opt);
    const typeDts = dts.trim();
    const allTypeDts = getDataSchemaType(omit(getGlobalConstantSchema(constList), 'id'), opt).trim();
    return { typeDts, allTypeDts };
});
/**
 * 全局常量 DTS 注入器
 */
export const globalConstantInjector = {
    placeholder: '/** inject-global-constant-dts */',
    async generate(projectId) {
        const { typeDts, allTypeDts } = await getGlobalConstantDts(projectId);
        const isBackendEnabled = getGogoBackendEnabled();
        if (!typeDts && !isBackendEnabled)
            return '';
        const frontDts = `
  /**
   * 仅限前端使用
   * 获取前端全局常量
   * @usage import { getGlobal } from '@wujibase/wuji';
   */
  export function getGlobal(): ${typeDts}`;
        if (!isBackendEnabled)
            return frontDts;
        const allDts = `
  /**
   * 仅限后端使用, BACKEND SERVICE ONLY
   * 获取所有全局常量，包括前端常量和后端需要的密钥常量等
   * @usage import { fetchAllGlobal } from '@wujibase/wuji';
   */
  export function fetchGlobalAndSecrets(): Promise<${allTypeDts}>`;
        return `${frontDts}${allDts}`;
    },
};
